import { CloseIcon, MoreIcon } from "asset/icons";
import axios from "axios";
import ActionDropdown from "component/actionDropdown";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { errorAlert, successAlert } from "utilities/alerts";
import { Bars } from "react-loader-spinner";
import Input from "component/form/Input";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import OTPInput from "component/form/OTPInput";
import RecordPayment from "./RecordPayment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import tradevuLogo from "asset/images/logo.png";


const MoreActions = ({
    business,
    order,
    orderId,
    tab,
    className,
    updateOrder,
    dropClassName,
    disableCancel,
    status,
    currency,
    wallets,
    totalAmount,
    isTradevuUser,
    refetchActivity,
}) => {
    const paymentDisables = ["pending", "rejected", "cancelled", "delayed", "decline", "declined"];
    const navigate = useNavigate();
    const [recordPaymentModal, setRecordPaymentModal] = useState(false);
    const [makePaymentModal, setMakeRecordPaymentModal] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");

    const userIsSupplier = type === "outbound";

    const downloadPdf = async () => {
        try {
            // Convert logo to data URL
            const logoDataUrl = await new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL('image/png'));
                };
                img.onerror = () => {
                    // Fallback to TC if image fails to load
                    resolve(null);
                };
                img.src = tradevuLogo;
            });
            const tax = (order.taxAmount ?? 0) + (order.subCharges ?? 0);
            const subTotal = order.totalAmount - tax;

            const container = document.createElement('div');
            container.style.position = 'fixed';
            container.style.left = '0';
            container.style.top = '0';
            container.style.width = '800px';
            container.style.height = 'auto';
            container.style.backgroundColor = 'white';
            container.style.padding = '20px';
            container.style.zIndex = '9999';
            container.style.transform = 'translateX(-100%)'; 
            
            document.body.appendChild(container);
            container.innerHTML = `
                <div style="font-family: Arial, sans-serif; background: white; width: 100%;">
                    <h3 style="display: flex; align-items: center; font-weight: 430; font-size: 19px; padding: 18px 30px; margin: 0; border-bottom: 3px solid rgb(233, 228, 249);">
                        ${logoDataUrl ? 
                            `<img src="${logoDataUrl}" alt="Tradevu" style="width: 32px; height: 35px; margin-right: auto;" />` : 
                            `<div style="width: 32px; height: 35px; background: #6F00FF; border-radius: 4px; display: flex; align-items: center; justify-content: center; margin-right: auto; color: white; font-weight: bold; font-size: 14px;">TC</div>`
                        }
                        PURCHASE ORDER
                    </h3>

                    <div style="display: grid; grid-template-columns: 43% 1fr; gap: 16px; padding: 0 30px; margin-top: 30px;">
                        <div style="display: flex;">
                            <div style="width: 42px; height: 42px; border-radius: 50%; background:rgb(233, 228, 249); display: flex; align-items: center; justify-content: center; margin-right: 10px; font-weight: 430; font-size: 17px; color: #6F00FF;">
                                ${(order?.outbound?.businessName).substring(0, 2).toUpperCase()}
                            </div>
                            <div>
                                <p style="margin: 0; font-size: 14px; font-weight: 500; color: #1F2937;">${order?.outbound?.businessName}</p>
                                <p style="margin: 1px 0 0 0; font-size: 13px; color: #6B7280; font-weight: normal;">${order?.outbound?.address || order?.outbound?.email || ''}</p>
                            </div>
                        </div>
                        
                        <div>
                            <p style="margin: 0; font-size: 14px; font-weight: 470; color: #1F2937;">To</p>
                            <p style="margin: 7px 0 5px 0; font-size: 14px; color: #1F2937;">${order?.inbound?.businessName || order?.outbound?.businessName}</p>
                            <p style="margin: 0; font-size: 13px; color: #6B7280; font-weight: normal;">${order?.inbound?.address || order?.outbound?.email || ''}</p>
                        </div>
                    </div>
                    
                    <p style="padding: 0 30px; margin-top: 26px; font-size: 14px; color: #1F2937;">Order Number: ${order.title}</p>
                    <p style="padding: 0 30px 16px 30px; margin-bottom: 26px; font-size: 14px; color: #1F2937;">Due: ${order?.deliveryDate ? dayjs(order.deliveryDate).format("MMM D, YYYY") : "No due date"}</p>
                    
                    <div style="margin: 0 30px;">
                        <div style="display: grid; grid-template-columns: 1fr 55px minmax(100px, 120px) minmax(100px, 115px); padding-bottom: 13px; margin-bottom: 9px; border-bottom: 1px solid #E5E7EB; font-size: 14px; color: #6B7280; font-weight: normal;">
                            <span>Items</span>
                            <span style="text-align: center;">Quantity</span>
                            <span style="text-align: right;">Unit Price</span>
                            <span style="text-align: right;">Total</span>
                        </div>
                        
                        ${(order?.orderItems || []).map(item => `
                            <div style="display: grid; grid-template-columns: 1fr 55px minmax(100px, 120px) minmax(100px, 115px); padding-bottom: 4px; margin-bottom: 3px; font-size: 15px; color: #1F2937; font-weight: normal;">
                                <span>${item.itemName || ""}</span>
                                <span style="text-align: center;">${(item.quantity || 0).toLocaleString()}</span>
                                <span style="text-align: right;">${currencyPairCheck(currency)}${(item.pricePerUnit || 0).toLocaleString()}</span>
                                <span style="text-align: right;">${currencyPairCheck(currency)}${((item.pricePerUnit || 0) * (item.quantity || 0)).toLocaleString()}</span>
                            </div>
                        `).join('')}
                        
                        <div style="display: grid; grid-template-columns: 47.5% 52.5%; padding-bottom: 4px; margin-bottom: 3px; border-top: 1px solid #E5E7EB;">
                            <span></span>
                            <p style="display: flex; align-items: center; justify-content: flex-end; padding: 18px 0; font-size: 15px; color: #1F2937; font-weight: normal;">
                                <span style="margin-right: auto; font-size: 14px; color: #6B7280; font-weight: normal;">Subtotal</span>
                                ${currencyPairCheck(currency)}${subTotal.toFixed(2)}
                            </p>
                        </div>
                        
                        <div style="display: grid; grid-template-columns: 47.5% 52.5%; padding-bottom: 4px; margin-bottom: 3px; border-top: 1px solid #E5E7EB;">
                            <span></span>
                            <p style="display: flex; align-items: center; justify-content: flex-end; padding: 18px 0; font-size: 15px; color: #1F2937; font-weight: normal;">
                                <span style="margin-right: auto; font-size: 14px; color: #6B7280; font-weight: normal;">Tax (7.5%)</span>
                                ${currencyPairCheck(currency)}${tax.toFixed(2)}
                            </p>
                        </div>
                        
                        <div style="display: grid; grid-template-columns: 47.5% 52.5%; padding-bottom: 4px; margin-bottom: 3px; border-top: 1px solid #E5E7EB;">
                            <span></span>
                            <p style="display: flex; align-items: center; justify-content: flex-end; padding: 18px 0; font-size: 15px; font-weight: 600; color: #1F2937;">
                                <span style="margin-right: auto; font-size: 14px; color: #6B7280; font-weight: normal;">Amount due</span>
                                ${currencyPairCheck(currency)}${(order?.totalAmount || 0).toFixed(2)}
                            </p>
                        </div>
                    </div>
                    
                    <div style="margin: 30px; border: 1px solid #f5f6fd; border-radius: 8px; padding: 14px;">
                        <p style="margin: 0; font-size: 13px; color: #6B7280; font-weight: normal;">Payment terms</p>
                        <p style="margin: 1px 0 0 0; font-size: 14px; font-weight: 500; color: #1F2937;">${order?.paymentTerms || "Full payment on completion"}</p>
                        ${order?.paymentTerms?.startsWith("Split") ? `
                            <p style="margin: 1.5px 0 0 0; font-size: 13px; color: #1F2937; font-weight: normal;">${order?.paymentOne || 0}% on confirmation, ${order?.paymentTwo || 0}% on completion</p>
                        ` : ''}
                        ${order?.note ? `
                            <p style="margin: 20px 0 0 0; font-size: 13px; color: #6B7280; font-weight: normal;">Notes</p>
                            <p style="margin: 1px 0 0 0; font-size: 14px; font-weight: 500; color: #1F2937;">${order.note}</p>
                        ` : ''}
                    </div>
                    
                    <p style="margin: 32px 30px 6px 30px; color: #ab6bff; font-weight: 375;">Thank you!</p>
                    <p style="margin: 0 30px 16px 30px; font-size: 12px; line-height: 17px; color: #6B7280; font-weight: 375;">
                        If you have questions for us, please call a representative on 
                        <a href="tel:+2347073183321" style="color: #6F00FF;">+2347073183321</a> or 
                        <a href="tel:+447903175084" style="color: #6F00FF;">+447903175084</a>. 
                        You can also send us an email at 
                        <a href="mailto:hello@tradevu.co" style="color: #6F00FF;">hello@tradevu.co</a>. 
                        Thank you for using Tradevu.
                    </p>
                </div>
            `;
            
            // Wait for the content to render
            await new Promise((resolve) => setTimeout(resolve, 200));
            
            // Generate PDF from the container
            const canvas = await html2canvas(container, { 
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff'
            });
            
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            
            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            const fileName = `Purchase-Order-${order?.inbound?.businessName || order?.outbound?.businessName || business?.name || "document"}.pdf`;
            pdf.save(fileName);
            
            // Clean up
            document.body.removeChild(container);
            
            // Show success message
            successAlert("PDF generated successfully!");
            
        } catch (error) {
            console.error("Error generating PDF:", error);
            errorAlert("Failed to generate PDF. Please try again.");
        }
    };
    

    const cancelOrder = async () => {
        try {
            setCancelLoading(true);
            await axios.put(`/v1/flex/order/update/${orderId}`, {
                orderStatus: "CONFIRMED",
            });
            updateOrder("CANCELLED");
        } catch (error) {
            errorAlert(error);
        } finally {
            setCancelLoading(false);
        }
    };
    const see = paymentDisables.includes(status) && isTradevuUser;

    return (
        <>
            <ActionDropdown
                dropClassName={dropClassName}
                className={`${cancelLoading && "pointer-events-none"}`}
                element={<MoreIcon className={`size-6 cursor-pointer ${className}`} />}
                options={[
                    {
                        label: "Download",
                        action: () => downloadPdf(),
                        closeAfterClick: true,
                    },
                    {
                        label: "Edit order",
                        action: () =>
                            navigate(`/flex/create-po?tab=${tab}&orderId=${orderId}&edit=true`),
                        disabled: status !== "pending",
                    },
                    {
                        label: "Make a payment",
                        action: () => setMakeRecordPaymentModal(true),
                        closeAfterClick: true,
                        disabled:
                            business?._id === order?.inbound?.businessId
                                ? true
                                : isTradevuUser
                                ? paymentDisables.includes(status)
                                : !paymentDisables.includes(status),
                    },
                    {
                        label: "Record a payment",
                        action: () => setRecordPaymentModal(true),
                        closeAfterClick: true,
                        disabled: paymentDisables.includes(status),
                    },
                    { label: "Ship this order", disabled: true },
                    { label: "Add to existing shipment", disabled: true },
                    {
                        label: "Duplicate this order",
                        action: () => navigate(`/flex/create-po?tab=${tab}&orderId=${orderId}`),
                    },
                    {
                        label: (
                            <>
                                Cancel order{" "}
                                {cancelLoading && <Bars color="#6F00FF" width={18} height={18} />}
                            </>
                        ),
                        className: "!gap-5",
                        action: () => cancelOrder(),
                        disabled: disableCancel,
                    },
                ]
                    .filter(({ disabled }) => !disabled)
                    .map(({ label, action, closeAfterClick, className }) => ({
                        label,
                        value: label,
                        action,
                        closeAfterClick,
                        className,
                    }))}
            />
            {makePaymentModal && (
                <MakePayment
                    currency={currency}
                    wallets={wallets}
                    orderId={orderId}
                    close={() => setMakeRecordPaymentModal(false)}
                />
            )}

                        {recordPaymentModal && (
                <RecordPayment
                    order={order}
                    orderId={orderId}
                    totalAmount={totalAmount}
                    close={() => setRecordPaymentModal(false)}
                    refetchActivity={refetchActivity}
                />
            )}
        </>
    );
};

const MakePayment = ({ currency, wallets, orderId, close }) => {
    const [step, setStep] = useState(0);
    const [otp, setOTP] = useState("");
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState();
    const currentBalance = wallets?.find(({ currency: curr }) => curr === currency);

    const makePayment = async () => {
        try {
            setLoading(true);
            await axios.post("/v1/users/verify-pin", { pin: otp });
            await axios.post(`/v1/flex/order/makepayment/${orderId}`, { amount });
            successAlert(`${formatMoney(amount)} paid successfully.`);
            close();
        } catch (error) {
            errorAlert(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="fixed left-0 top-0 h-screen w-screen bg-[#1D29394D] z-[5000] grid place-items-center cursor-auto"
            onClick={(evt) => evt.stopPropagation()}
        >
            <div className="bg-page-bg rounded-2xl w-[95%] sm:w-[560px] !pt-1">
                <h3 className="flex justify-between text-main-dark font-semibold text-[23px] !px-6 !py-4 -mb-1.5">
                    {step ? "Confirm" : "Make a"} payment
                    <CloseIcon
                        className={`size-6 cursor-pointer translate-x-1 ${
                            loading && "pointer-events-none *:stroke-main-grey/60"
                        }`}
                        onClick={close}
                    />
                </h3>
                <p className="text-[#6B7280] !px-6 font-[380]">
                    {step
                        ? "Enter your PIN to confirm this payment"
                        : "Pay for this purchase order from your Tradevu account"}
                </p>

                {step ? (
                    <div className="!px-6 mt-9 mb-[25px]">
                        <OTPInput otp={otp} setOTP={setOTP} />
                    </div>
                ) : (
                    <>
                        <div className="flex items-end !gap-2 !px-6 !mt-7">
                            <div className="basis-[150px] *:first-of-type:pointer-events-none">
                                <Input
                                    placeholder="NGN"
                                    value={currency}
                                    require={false}
                                    label="Amount to pay"
                                    labelClassName="!text-[#667085] !mb-1"
                                />
                            </div>

                            <Input
                                onChange={setAmount}
                                type="number"
                                value={amount}
                                placeholder="3,000,000"
                                formatType="integer"
                            />
                        </div>
                        <p className="!px-6 !mt-1.5 font-normal text-[13px] text-main-grey">
                            Current balance:
                            <span className="font-[450] ml-1.5">
                                {currencyPairCheck(currency)} {formatMoney(currentBalance?.balance)}
                            </span>
                        </p>
                    </>
                )}

                <div className="flex justify-end items-center !gap-6 !border-t !border-[#E7E9FB] !py-[18px] !px-6 mt-[21px]">
                    {!!step && (
                        <span
                            className="cursor-pointer text-main-dark/85"
                            onClick={() => setStep(0)}
                        >
                            Go back
                        </span>
                    )}
                    <button
                        className={`bg-[#6F00FF] rounded-lg h-10  ${
                            step ? "w-[101px]" : "w-[154px]"
                        } text-[#FBFAFF] font-[450] disabled:bg-secondary/30`}
                        disabled={(step ? otp.length !== 4 : !amount) || loading}
                        onClick={() => (step ? makePayment() : setStep(1))}
                    >
                        {loading ? (
                            <Bars
                                color="#fff"
                                height={23}
                                width={23}
                                wrapperClass="w-max mx-auto"
                            />
                        ) : step ? (
                            "Submit"
                        ) : (
                            "Make payment"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MoreActions;
